import { useApi } from './useApi';

export function useParcels() {
  const { fetchData, postData, putData, deleteData, data, error, loading } = useApi();

  const exportParcelsApi = (payload) =>
    postData('/api/parcels/export', payload, { responseType: 'blob' });

  const exportManifestApi = (payload) =>
    postData('/api/parcels/export-manifest', payload, { responseType: 'blob' });
  
  const fetchParcelsApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/parcels', { params });

      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message || 'Lỗi kết nối'
      };
    }
  };

  const deleteParcelApi = async (id) => {
    try {
      const result = await deleteData(`/api/parcels/${id}`);
      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message || 'Lỗi khi xóa'
      };
    }
  };

  const getParcelDetailApi = async (id) => {
    try {
      const result = await fetchData(`/api/parcels/${id}?include=items,customer&searchJoin=AND`);
      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message || 'Lỗi kết nối'
      };
    }
  };

  const createParcelApi = async (credentials) => {
    try {
      const result = await postData('/api/parcels/create-parcel', credentials);
      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message
      };
    }
  };

  const updateParcelApi = async (id, credentials) => {
    try {
      const result = await putData(`/api/parcels/${id}`, credentials);

      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message || 'Lỗi kết nối'
      };
    }
  };

  return {
    fetchParcelsApi,
    deleteParcelApi,
    createParcelApi,
    getParcelDetailApi,
    updateParcelApi,
    exportParcelsApi,
    exportManifestApi,
  };
}
